export const SET_TALENTA='SET_TALENTA'
export const SET_TALENTA_TEST='SET_TALENTA_TEST'